import { useMemo, useState } from 'react';

export const useSortArray = ({ items, defaultField = '', dateField = 'createdAt' }, isMobile = false) => {
  const [sortBy, setSortBy] = useState({ isOpen: false, type: '', direction: 'desc' });

  const parseNumber = value => {
    if (typeof value !== 'string') return value;
    const cleaned = value.replace(/\./g, '').replace(/,/g, '.');
    return parseFloat(cleaned) || 0;
  };
  const handleSetSortBy = value => {
    setSortBy(value);
  };

  const handleSortClick = (field = null) => {
    if (!sortBy.type) {
      handleSetSortBy({
        ...sortBy,
        type: isMobile ? defaultField : field,
        direction: 'asc',
      });
    } else {
      const newDirection = sortBy.direction === 'asc' ? 'desc' : 'asc';
      handleSetSortBy({
        ...sortBy,
        direction: newDirection,
      });
    }
  };

  const sortedItems = useMemo(() => {
    let sortedData = [...items];
    if (sortBy.type) {
      sortedData.sort((a, b) => {
        const isDateField = sortBy.type === dateField;
        let aValue = a[sortBy.type];
        let bValue = b[sortBy.type];

        aValue = parseNumber(isDateField ? new Date(aValue).getTime() : aValue);
        bValue = parseNumber(isDateField ? new Date(bValue).getTime() : bValue);

        if (aValue < bValue) {
          return sortBy.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortBy.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortedData;
  }, [items, sortBy.type, sortBy.direction, dateField]);

  return { sortedItems, sortBy, handleSetSortBy, handleSortClick };
};
